"use client";
import Image from "next/image";
import React, { useCallback } from "react";
import { AiOutlineUsergroupAdd } from "react-icons/ai";
import { FaClock, FaPlane } from "react-icons/fa";
import { FlightData } from "../../../../../interfaces/flightData";
import { FlightTypeEnum } from "../../../../../enum/flightType";
import moment from "moment";
import { useTranslations } from "next-intl";
import { Dialog } from "@/components/ui/dialog";
import { QuotationConfirmationModal } from "@/components/quotation/quotation-confirmation-modal";
import { useParams } from "next/navigation";

const SingleFlightCard = ({ flight, distance, type, route }) => {
  const { locale } = useParams();
  const t = useTranslations("estimatePage");
  const [showModal, setShowModal] = React.useState(false);

  const getPrice = useCallback(
    (data: FlightData) => {
      let response: any;
      if (type === FlightTypeEnum.ONEWAY) {
        response = Math.floor(
          ((Number(distance) * 2) / Number(data?.avgSpeed)) * Number(data.price)
        ).toLocaleString();
      } else if (type === FlightTypeEnum.ROUNDWAY) {
        let days = moment(route[0].returnDate).diff(
          moment(route[0].departureDate),
          "days"
        );
        if (days > 2) {
          response = Math.floor(
            ((Number(distance) * 2) / Number(data?.avgSpeed)) *
              Number(data.price) *
              2
          ).toLocaleString();
        } else {
          response = Math.floor(
            ((Number(distance) * 2) / Number(data?.avgSpeed)) *
              Number(data.price)
          );
          response += response * 0.1;
        }
      } else if (type === FlightTypeEnum.MULTICITY) {
        response = Math.floor(
          (Number(distance) / Number(data?.avgSpeed)) * Number(data.price)
        ).toLocaleString();
      }

      return response;
    },
    [distance, type, route]
  );

  const price = getPrice(flight);

  return (
    <>
      <div className="flex flex-col gap-6 bg-white rounded-xl w-full p-2">
        <div className="relative h-[250px] w-full rounded-lg overflow-hidden shrink-0 shadow-md">
          <Image src={flight?.image} alt="Large Heavy Jet Image" fill />
        </div>
        <div className="p-4 pt-0 relative flex flex-col w-full h-full">
          {/* <p className={styles.badge}>Recomended</p> */}
          <h3 className="text-xl text-[#212121] relative capitalize font-medium">
            {flight?.categoryName}
          </h3>
          <div className="flex-1">
            <p className="my-4 text-[#9b9b9b] text-sm">
              {flight.jets.join(", ")}
            </p>
            <ul className="list-none flex flex-wrap gap-2">
              <li className="text-[#9b9b9b] text-sm flex justify-start items-center gap-4 relative after:content-['|'] after:pr-2">
                <AiOutlineUsergroupAdd />{" "}
                <span>
                  {flight.min_capicity} - {flight.max_capicity}
                </span>
              </li>
              <li className="text-[#9b9b9b] text-sm flex justify-start items-center gap-4 relative  after:content-['|'] after:pr-2">
                <FaPlane />{" "}
                <span>
                  {flight.min_range} - {flight.max_range} nm
                </span>
              </li>
              <li className="text-[#9b9b9b] text-sm flex justify-start items-center gap-4 relative">
                <FaClock />{" "}
                <span>
                  {flight.min_flight_hours} - {flight.max_flight_hours} hours
                </span>
              </li>
            </ul>
          </div>
          <hr className="my-4 border-t-[#ccc]" />
          <div className="flex justify-between items-center gap-2 flex-col sm:flex-row">
            <div>
              <p className="text-sm text-[#9b9b9b]">Price Estimated</p>
              <p className="mt-1 whitespace-nowrap text-xl">$ {price}</p>
            </div>
            <button
              className="w-full sm:w-auto bg-[#5a558e] text-white text-center py-2 px-4 rounded text-sm font-medium hover:bg-[#4a4a7a] transition-colors"
              onClick={() => setShowModal(true)}
            >
              {locale === "en" ? "Check Availability" : "تحقق من التوفر"}
            </button>
            {/* <div>
            </div> */}
            {/* <p>${Math.floor(Number(price)).toLocaleString()}</p> */}
            {/* <button onClick={(e) => onOpen()}>Check Availability</button> */}
          </div>
          <p className="text-[#dc4c64] text-xs mt-4">{t("price-warn")}</p>
        </div>
      </div>

      {showModal && (
        <Dialog onClose={() => setShowModal(false)}>
          <QuotationConfirmationModal
            flight={flight}
            price={price}
            query={route}
          />
        </Dialog>
      )}
    </>
  );
};

export default SingleFlightCard;
